import React, { useMemo } from "react";
import { Badge } from "react-bootstrap";
import AuditionActionsCell from "./AuditionActionsCell";

const useAuditionColumns = ({ handleViewApplication }) => {
    return useMemo(
        () => [
            {
                accessorKey: "id",
                header: "#",
                cell: (info) => info.row.index + 1,
            },
            {
                accessorKey: "roleId",
                header: "Role ID",
            },
            {
                accessorKey: "applicationId",
                header: "Application ID",
            },
            {
                accessorKey: "candidateName",
                header: "Candidate",
            },
            {
                accessorKey: "castingDirector",
                header: "Casting Director",
            },
            {
                accessorKey: "roleName",
                header: "Role Name",
            },
            {
                accessorKey: "auditionType",
                header: "Audition Type",
                cell: (info) => (
                    <Badge bg="info">
                        {info.getValue() || "N/A"}
                    </Badge>
                ),
            },
            {
                accessorKey: "paymentStatus",
                header: "Payment",
                cell: (info) => {
                    const status = info.getValue();
                    return (
                        <Badge
                            bg={
                                status === "BOOKED"
                                    ? "success"
                                    : status === "PENDING"
                                    ? "warning"
                                    : "secondary"
                            }
                        >
                            {status || "N/A"}
                        </Badge>
                    );
                },
            },
            {
                accessorKey: "paymentId",
                header: "Payment ID",
            },
            {
                accessorKey: "auditionDate",
                header: "Audition Date",
            },
            {
                accessorKey: "auditionMonth",
                header: "Month",
            },
            {
                accessorKey: "verifyStatus",
                header: "Verify Status",
                cell: (info) => {
                    const status = info.getValue();
                    return (
                        <Badge
                            bg={
                                status === "VERIFIED"
                                    ? "success"
                                    : "warning"
                            }
                        >
                            {status || "Pending"}
                        </Badge>
                    );
                },
            },
            {
                accessorKey: "status",
                header: "Status",
                cell: (info) => {
                    const status = info.getValue();
                    return (
                        <Badge
                            bg={
                                status === "ACTIVE"
                                    ? "success"
                                    : "secondary"
                            }
                        >
                            {status || "N/A"}
                        </Badge>
                    );
                },
            },
            {
                id: "actions",
                header: () => <div style={{ textAlign: "center", width: "100%" }}>ACTIONS</div>,
                cell: (info) => (
                    <AuditionActionsCell
                        roleApplicationId={info.row.original.roleApplicationId}
                        onView={handleViewApplication}
                    />
                ),
            },
        ],
        [handleViewApplication]
    );
};

export default useAuditionColumns;
